<div class="container" [@esvanecerDesvanecer]="'in'">
  <div class="text-center">
    <img class="logo_externo" [src]="logomarca" alt="Logo" />
  </div>

  <div class="col-sm-12 text-center pt-5 pb-5">
    <h4 class="text-secondary">Recuperar Senha</h4>
    <h6 class="text-secondary">Informe seu e-mail adicionado para receber instruções de recuperação!</h6>
  </div>

  <div class="d-flex justify-content-center">
    <div class="col-sm-5">
      <form [formGroup]="formRecuperarSenha" (ngSubmit)="recuperar()">
        <div class="form-group">
          <label><b>E-mail:</b></label>

          <input class="form-control form-control-sm" type="email" name="email" [ngClass]="{ 'is-invalid' : enviado && f.email.errors?.required }" formControlName="email" />

          @if (enviado && f.email.errors?.required) {
            <div class="erro pt-1">E-mail em branco!</div>
          }
        </div>

        <hr class="mt-2 mb-2" />

        <div class="col-sm-12 text-center p-0">
          <button type="submit" class="btn btn-info btn_externo">Recuperar</button>
        </div>

        <div class="col-sm-12 text-center pt-4">
          <a routerLink="/login">Voltar</a>
        </div>
      </form>
    </div>
  </div>
</div>
